<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Danh sách xe tuyến" :link="[{ text: 'Xe tuyến', href: '../busList' }]" />
      </div>
      <div class="flex-center" v-if="isEditDocument">
        <v-btn depressed dark color="primary" @click="newDialog = !newDialog"> Thêm tuyến mới </v-btn>
      </div>
    </div>

    <v-card v-if="role.type !== 'buslist'" outlined class="pa-6 mx-4 mb-6 elevation-0">
      <BusFilter @onFilterChanged="refresh" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <BusDataTable ref="busesDataTable" />
    </v-card>
    <BusNewDialog :state="newDialog" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapGetters } from 'vuex'
import BusFilter from '@/modules/bus/BusFilter'
import BusDataTable from '@/modules/bus/BusDataTable.vue'
import BusNewDialog from '@/modules/bus/busNewDialog.vue'

export default {
  components: { Breadcrumbs, BusFilter, BusDataTable, BusNewDialog },
  data: () => ({ newDialog: false, selected: [] }),
  computed: { ...mapGetters('auth', ['role', 'isEditDocument']) },
  methods: {
    async refresh(query) {
      this.$refs.busesDataTable.refresh(query)
    },
  },
}
</script>
